<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-01">The One remains, the many change and pass;</p>
<p class="fm-02">Heaven’s light forever shines, Earth’s shadows fly;</p>
<p class="fm-02">Life, like a dome of many-coloured glass,</p>
<p class="fm-02">Stains the white radiance of Eternity …</p>
<p class="fm-03">Percy Bysshe Shelley</p>
<p class="fm-04"><i>Adonais</i> LII</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter04.vue?15f35009